import styled from "styled-components";
import {Modal, Form, Button, Checkbox} from "antd";

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 12px;
        box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #aeef01 0%, #9dd400 100%);
        border-bottom: none;
        padding: 20px 24px;
        border-radius: 12px 12px 0 0;

        .ant-modal-title {
            color: #000;
            font-weight: 600;
            font-size: 18px;
            margin: 0;
        }
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            color: #000;
            font-size: 16px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            transition: all 0.3s ease;
            border-radius: 50%;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 32px;
        background: #fff;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 20px 24px;
        background: #fff;
        border-radius: 0 0 12px 12px;
    }
`;

export const FormContainer = styled.div`
    .form-title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 24px;
        text-align: center;
        color: #333;
        padding-bottom: 16px;
        border-bottom: 2px solid #f0f0f0;
    }

    .section-title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 16px;
        color: #333;
        border-left: 4px solid #aeef01;
        padding-left: 12px;
    }

    .info-text {
        font-size: 16px;
        line-height: 1.8;
        color: #666;
        margin-top: 20px;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border-left: 4px solid #aeef01;

        b {
            color: #333;
        }
    }
`;

export const StyledForm = styled(Form)`
    text-align: left;

    .ant-form-item {
        margin-bottom: 16px;
    }

    .ant-form-item-label > label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
    }
`;

export const StyledCheckbox = styled(Checkbox)`
    &.ant-checkbox-wrapper {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        padding: 12px 16px;
        border-radius: 8px;
        border: 2px solid #f0f0f0;
        transition: all 0.3s ease;
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        &:hover {
            border-color: #aeef01;
            background: #f9fff0;
        }

        &.ant-checkbox-wrapper-checked {
            border-color: #aeef01;
            background: #f9fff0;
        }

        &.ant-checkbox-wrapper-disabled {
            background: #fafafa;
            border-color: #e8e8e8;
            color: #bfbfbf;
        }
    }

    .ant-checkbox {
        .ant-checkbox-inner {
            width: 18px;
            height: 18px;
            border-radius: 4px;

            &:after {
                width: 6px;
                height: 10px;
            }
        }

        &.ant-checkbox-checked .ant-checkbox-inner {
            background-color: #aeef01;
            border-color: #aeef01;

            &:after {
                border-color: #000;
            }
        }
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 24px;

    .ant-btn {
        height: 44px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 16px;
        transition: all 0.3s ease;

        &.ant-btn-primary {
            background: #aeef01;
            border-color: #aeef01;
            color: #000;

            &:hover:not(:disabled) {
                background: #9dd400;
                border-color: #9dd400;
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(174, 239, 1, 0.3);
            }

            &:disabled {
                background: #f5f5f5;
                border-color: #d9d9d9;
                color: #bfbfbf;
            }
        }

        &.ant-btn-default {
            border-color: #d9d9d9;
            color: #666;

            &:hover:not(:disabled) {
                border-color: #aeef01;
                color: #aeef01;
                transform: translateY(-1px);
            }
        }
    }
`;

export const LoadingText = styled.b`
    color: #aeef01;
    font-weight: 600;
`;

// Error Modal için özel stil
export const ErrorModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 10px;
        box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.15);
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%);
        border-bottom: none;
        padding: 16px 20px;
        border-radius: 10px 10px 0 0;

        .ant-modal-title {
            color: #fff;
            font-weight: 600;
            font-size: 16px;
        }
    }

    .ant-modal-close {
        .ant-modal-close-x {
            color: #fff;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 20px;

        p {
            font-size: 15px;
            line-height: 1.6;
            color: #333;

            ul {
                margin-top: 12px;
                padding-left: 20px;

                li {
                    margin-bottom: 4px;
                    color: #666;
                }
            }
        }
    }

    .ant-modal-footer {
        .ant-btn-primary {
            background: #ff4d4f;
            border-color: #ff4d4f;

            &:hover {
                background: #ff7875;
                border-color: #ff7875;
            }
        }
    }
`;
